<template>
  <div class="d-flex flex-row flex-nowrap">
    <b-button
        v-if="showDuplicateButton"
        @click="showDuplicateModal = true"
        v-b-tooltip.hover title="Duplicate event"
        variant="outline-primary"
        class="border-0 p-1 mr-2"
        style="height: 34px; width: 34px"
    >
      <i class="far fa-clone fa-lg"></i>
    </b-button>
    <modal
        @ok="duplicateItem"
        :confirm="$i18n.t('button.duplicate')"
        @hide="showDuplicateModal = false"
        :showModal="showDuplicateModal">
      <template slot="body">
        <h3 class="text-center">{{ $t('global.are_you_sure') }}</h3>
      </template>
    </modal>

    <router-link :to="route" v-if="route && showEditButton">
      <b-button
        variant="outline-primary"
        class="border-0 p-1"
        style="height: 34px; width: 34px"
      >
        <i class="far fa-edit fa-lg"></i>
      </b-button>
    </router-link>
    <b-button
      v-if="!route && showEditButton"
      @click="goToRoute"
      variant="outline-primary"
      class="border-0 p-1"
      style="height: 34px; width: 34px"
    >
      <i class="far fa-edit fa-lg"></i>
    </b-button>

    <b-button
      @click="showModal = true"
      v-if="showDeleteButton"
      variant="outline-primary"
      style="height: 34px; width: 34px"
      class="ml-2 border-0 p-1"
      :disabled="deleteDisabled"
    >
      <i class="far fa-trash-alt fa-lg"></i>
    </b-button>
    <modal
      @ok="deleteItems"
      @hide="showModal = false"
      :showModal="showModal">
      <template slot="body">
        <h3 class="text-center">{{$t('global.are_you_sure')}}</h3>
      </template>
    </modal>
  </div>
</template>

<script>
  export default {
    name: 'ColumnAction',
    props: {
      route: {
        type: Object
      },
      showDeleteButton: {
        type: Boolean,
        default: true
      },
      showEditButton: {
        type: Boolean,
        default: true
      },
      showDuplicateButton: {
        type: Boolean,
        default: false
      },
      deleteUrl: {
        type: String
      },
      duplicateUrl: {
        type: String
      },
      deleteDisabled: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        showModal: false,
        showDuplicateModal: false
      }
    },
    methods: {
      deleteItems() {
        this.deleteData(this.deleteUrl).then(resp => {
          if (resp) {
            this.$emit('deleteItems')
          }
        })
      },
      duplicateItem () {
        this.postData(this.duplicateUrl).then(resp => {
          if (resp) {
            this.$emit('duplicateItem', resp.data)
          }
        })
      },
      goToRoute() {
        this.$emit('edit')
      }
    }
  }
</script>
